import { render, staticRenderFns } from "./page-select.vue?vue&type=template&id=9e5b3e98"
import script from "./page-select.vue?vue&type=script&lang=js"
export * from "./page-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins-data/workspace/front-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e5b3e98')) {
      api.createRecord('9e5b3e98', component.options)
    } else {
      api.reload('9e5b3e98', component.options)
    }
    module.hot.accept("./page-select.vue?vue&type=template&id=9e5b3e98", function () {
      api.rerender('9e5b3e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/heraip/packages/page-select/src/page-select.vue"
export default component.exports